import { ContentObserver } from '@angular/cdk/observers';
import { Injectable, NgZone } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { runInZone } from './zone';

@Injectable({ providedIn: 'root' })
export class ContentService {
  constructor(
    private readonly contentObserver: ContentObserver,
    private readonly zone: NgZone,
  ) {}

  observe(element: HTMLElement): Observable<void> {
    return new Observable(subscriber =>
      this.zone.runOutsideAngular(() =>
        this.contentObserver
          .observe(element)
          .pipe(
            // protect against non-OnPush components, where rendering seems to always
            // update comment nodes
            filter((mutations: MutationRecord[]) =>
              mutations.some(
                mutation => mutation.target.nodeType !== Node.COMMENT_NODE,
              ),
            ),
            map(() => {
              return undefined;
            }),
            runInZone(this.zone),
          )
          .subscribe(subscriber),
      ),
    );
  }
}
